module.exports = __webpack_public_path__ + "img/google.fd5bee20.svg";